/**
 * A place for internal Ajax services to the ServicesController
 */
namespace appn.services {

    /**
     * Validates a date and time format mask
     * @param value
     * @param resultLabel
     */
    export function validateDateFormat(value: string, resultLabel: JQuery<HTMLElement>) {
        // Show loading
        resultLabel.html(ui.getSpinner());

        appn.ajax.post({
            url: appn.urls.services.ajaxValidateDateFormat,
            data: { format: value },
            dataType: 'json',
            done: function(data: any) {
                if (data) {
                    resultLabel.html(data);
                    return;
                }

                resultLabel.html(`<span class="badge label-danger">${T('Unable to validate.')}</span>`);
            },
            fail: function() {
                resultLabel.html(`<span class="badge label-danger">${T('Unable to validate.')}</span>`);
            }
        });
    }

    /**
     * Sends a simple request to the Platform Ping controller
     */
    export function pingPlatform() {
        appn.ajax.get({
            url: appn.urls.services.ajaxPing,
            done: function(data: any, textStatus: string, jqXHR: JQueryXHR) {
                ui.validateSessionFromAjax(jqXHR);
            }
        });
    }

    export function startPingTimer() {
        // Pings the server periodically (5 minutes) to check for a lost session
        setInterval(function() {
            pingPlatform();
        }, 60000 * 5); // Every 5 minutes
    }

    /**
     * Finds a GPS location based on Address info input
     */
    export function findLocationFromAddress(address: string, onSuccessCallback: Function) {
        appn.ajax.get({
            url: appn.urls.services.ajaxFindLocation,
            data: { address: address },
            done: function(data: any) {
                onSuccessCallback(data);
            },
            fail: function() {
                appn.dialog.alert({
                    modalColor: 'modal-danger',
                    title: T('Address Lookup Failed'),
                    message: T('Something went wrong when attempting to find the location data.'),
                    buttons: {
                        ok: {
                            label: '<span>' + T('OK') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    autoHeaderIcon: false
                });
            }
        });
    }
}
